<template lang="pug">
  header.b-header
    ._container
      HeaderBurgerButton._burger(
        :class="{ 'md-hide': !showBurgerOnMd }"
        :opened="burgerOpened",
        @click="$emit('burgerClick', $event)"
        )
      router-link._logo(:to="{ name: 'home' }")
        Icon(name="logo" pointer)
      HeaderUserMenu
    ._slot
      slot
    .overlay
</template>

<script>
import HeaderUserMenu from '@/components/HeaderUserMenu.vue';
import HeaderBurgerButton from '@/components/HeaderBurgerButton.vue';

export default {
  name: 'TheHeader',
  components: { HeaderBurgerButton, HeaderUserMenu },
  props: {
    showBurgerOnMd: {
      type: Boolean,
      default: false,
    },
    burgerOpened: Boolean,
  },
};
</script>

<style scoped lang="scss">
.header {
  position: static;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.15)), linear-gradient(180deg, #2393FF 0%, #35A3FB 100%);
  color: var(--color-white);

  &__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 10px 32px 34px;
  }
  &__right {
    display: flex;
    align-items: center;
  }

  &__logo {
    font-weight: 800;
    font-size: 20px;
  }

  @media (min-width: 1900px) {
    &__container {
      padding: 16px 10px 16px calc(10vw - 118px);
    }
  }

  @media (min-width: 1025px) {
    &__burger {
      display: none;
    }
  }

  @media (min-width: 769px) {
    &__burger.md-hide {
      display: none;
    }
  }

  @media (max-width: 1366px) {
    &__container {
      max-width: none;
      padding: 16px 25px 40px;
    }
  }

  @media (max-width: 1024px) {
    &__logo {
      font-size: 15px;
    }
  }

  @media (max-width: 768px) {
    &__container {
      padding: 72px 25px;
      align-items: center;
    }

    &__logo {
      font-size: 20px;
    }
  }

  @media (max-width: 500px) {
    &__container {
      padding-left: 15px;
      padding-right: 15px;
    }
  }

  @media (max-width: 360px) {
    &__container {
      padding: 52px 15px 48px 16px;
    }
  }
}
</style>
